import * as React from "react";
const DeliveryIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height={19}
    width={20}
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    {...props}
  >
    <path
      fill={props.color ? props.color : "black"}
      d="M447.77 33.653c-36.385-5.566-70.629 15.824-82.588 49.228h-44.038v37.899h40.902c5.212 31.372 29.694 57.355 62.855 62.436 41.278 6.316 79.882-22.042 86.222-63.341 6.305-41.3-22.053-79.906-63.353-86.222M162.615 338.222c0-6.88-5.577-12.468-12.468-12.468H96.16c-6.891 0-12.467 5.588-12.467 12.468 0 6.868 5.576 12.467 12.467 12.467h53.988c6.89 0 12.467-5.598 12.467-12.467"
    />
    <path
      fill={props.color ? props.color : "black"}
      d="M392.999 237.965 284.273 340.452l-37.966 9.398v-86.619H0v215.996h246.307v-59.454l35.547-5.732c16.95-2.418 29.396-6.692 44.336-15.018l46.302-24.228v104.432h132.435V270.828c0-68.21-76.911-68.398-111.928-32.863M215.996 448.913H30.313v-155.37h185.683v63.805l-36.419 9.01c-15.968 4.395-25.708 20.518-22.174 36.696l.298 1.247c3.478 15.912 18.651 26.436 34.785 24.14l23.51-3.788z"
    />
  </svg>
);
export default DeliveryIcon;